/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const organisationPipelineConfigDataSchema = z.object({
	organisationId: z.string(),
	stages: z.array(z.object({ id: z.string(), name: z.string(), locked: z.boolean() })),
	isCustomized: z.boolean(),
	source: z.string(),
})

export type OrganisationPipelineConfigDataSchema = z.infer<typeof organisationPipelineConfigDataSchema>
